var readMoreButton = document.querySelector('.read-more-button');
readMoreButton.addEventListener('click', function(event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.read-more-full');
  descriptionFull.style.display = 'block';
  var descriptionShort = document.querySelector('.read-more-short');
  descriptionShort.style.display = 'none';
});

var readLessButton = document.querySelector('.read-less-button');
readLessButton.addEventListener('click', function(event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.read-more-full');
  descriptionFull.style.display = 'none';
  var descriptionShort = document.querySelector('.read-more-short');
  descriptionShort.style.display = 'block';
});  